/**
 * Sesi konsol portal — token disimpan di `localStorage`.
 *
 * ### ⚠️ Kenapa `localStorage`, dan apa yang ditukar
 * Cookie `HttpOnly` lebih tahan XSS, tapi menuntut portal & API satu situs (atau CORS bersertifikat)
 * — keputusan penempatan yang belum diambil. `localStorage` dipilih **sadar**, dengan konsekuensi
 * yang dituliskan: satu skrip pihak ketiga yang lolos ke halaman ini bisa membaca tokennya.
 *
 * ⇒ Karena itu konsol ini **tak memuat skrip pihak ketiga sama sekali** (tanpa analitik, tanpa CDN).
 *   Kalau kelak ada, keputusan ini harus ditinjau ulang lebih dulu, bukan sesudahnya.
 */
const KUNCI = 'osbpos.portal.session';

export interface PortalSession {
  readonly token: string;
  readonly tenant: string;
  readonly displayName: string;
  /** `owner` | `manager` | `viewer` | `outlet` (sesi PIN di outlet). */
  readonly role: string;
  readonly scopes: readonly string[];
  /** Terisi hanya pada sesi PIN outlet. */
  readonly outletCode?: string;
  /** Detik epoch. */
  readonly exp: number;
}

let memori: PortalSession | undefined;

export function session(): PortalSession | undefined {
  if (memori !== undefined) return memori;
  const raw = globalThis.localStorage?.getItem(KUNCI);
  if (raw === null || raw === undefined || raw === '') return undefined;
  try {
    const s = JSON.parse(raw) as PortalSession;
    /*
     * ⚠️ Kedaluwarsa diperiksa DI SINI, bukan dibiarkan sampai server menolak. Konsol yang
     * menampilkan menu lengkap lalu gagal di tiap klik terbaca sebagai "aplikasinya rusak",
     * bukan sebagai "sesi Anda habis".
     */
    if (s.exp * 1000 <= Date.now()) { logout(); return undefined; }
    memori = s;
    return s;
  } catch {
    logout();
    return undefined;
  }
}

export function saveSession(s: PortalSession): void {
  memori = s;
  globalThis.localStorage?.setItem(KUNCI, JSON.stringify(s));
}

export function logout(): void {
  memori = undefined;
  globalThis.localStorage?.removeItem(KUNCI);
}

/** ⭐ Layar menyembunyikan yang tak boleh, bukan menampilkannya lalu ditolak server. */
export function canWrite(): boolean {
  return session()?.scopes.includes('master:write') === true;
}
